export const inspectData_1_1 = [
  {
    title: "일기예보 사전관리",
    titleRow: 1,
    label: "집중호우 발생지역,기간,강우량 사전확인 <br/> - 6~8월 장마기간 일기기록부 작성 및 관리",
    is_checked: "",
  },
  {
    title: "수방자재 확보여부",
    titleRow: 1,
    label: "양수기, 천막, 마대, 우비관련 등의 장구 등의 확보<br/>- 양수기의 경우 여유분 확보 및 작동상태 수시점검",
    is_checked: "",
  },
  {
    title: "비상연락망 구축여부",
    titleRow: 2,
    label: "광범위한 비상연락망 구축<br/>- 발주처, 소방서, 병원 등 유관기관 포함",
    is_checked: "",
  },
  {
    title: "비상연락망 구축여부",
    titleRow: false,
    label: "현장 비상대기반 편성·운영<br/>- 집중호우시 비상대기반 24시간 운영",
    is_checked: "",
  },
  {
    title: "비상대책 수립여부",
    titleRow: 1,
    label: "비상사태 발생시 대책수립 여부<br/>- 근로자 대피계획, 장비 및 자재보호계획 등",
    is_checked: "",
  },
];

export const inspectData_1_2 = [
  {
    title: "배수시설 정비상태",
    titleRow: 3,
    label: "배수로 확보 및 막힘 여부 확인",
    is_checked: "",
  },
  {
    title: "배수시설 정비상태",
    titleRow: false,
    label: "필요시 집수정 및 침사지 추가 설치",
    is_checked: "",
  },
  {
    title: "배수시설 정비상태",
    titleRow: false,
    label: "현장주변 배수시설과 연계상태(오수·우수관로)",
    is_checked: "",
  },
  {
    title: "장비 및 자재관리",
    titleRow: 2,
    label: "장비 자재 이동 및 보관계획<br/>- 침수피해 방지를 위해 안전한 지역으로 이동조치",
    is_checked: "",
  },
  {
    title: "장비 및 자재관리",
    titleRow: false,
    label: "각종자재 정리정돈 및 결속상태 확인",
    is_checked: "",
  },
  {
    title: "주변여건 상태확인",
    titleRow: 3,
    label: "공사장 주변 지반상태 및 인접구조물 상태 확인<br/>- 주변지반 침하, 균열, 발생여부 확인<br/>- 인접 구조물 기울어짐, 벽체 균열 발생여부 확인",
    is_checked: "",
  },
  {
    title: "주변여건 상태확인",
    titleRow: false,
    label: "공사장 주변 지하매설물 상태 확인<br/>- 가스관, 상수관, 등의 고압관로 상태 확인",
    is_checked: "",
  },
  {
    title: "주변여건 상태확인",
    titleRow: false,
    label: "강풍대비 가설구조물 결속상태 확인<br/>- 가설울타리, 외부비계 결속상태 수시점검",
    is_checked: "",
  },
];

export const inspectData_2_1 = [
  {
    title: "일반사항",
    titleRow: 6,
    label: "안전통로 확보여부<br />- 안전통로 확보 및 사용상태 유지 여부<br />- 통로 주변 안전표지 등 통로 표시 상태",
    is_checked: "",
  },
  {
    title: "일반사항",
    titleRow: false,
    label: "비계 상 추락방지<br />- 작업발판 구조 및 안전난간 설치 상태<br />- 추락방호망 설치 상태",
    is_checked: "",
  },
  {
    title: "일반사항",
    titleRow: false,
    label: "철골작업시 추락방지<br />- 승강로 설치 상태<br />- 추락방호망 및 안전대 부착설비 설치 상태<br />- 안전대 및 부속설비 이상유무 확인",
    is_checked: "",
  },
  {
    title: "일반사항",
    titleRow: false,
    label: "지붕작업시 추락방지<br />- 폭 30cm이상 작업발판 설치 상태<br />- 하부 추락방호망 설치 상태<br />- 지붕단부 안전난간 설치 유무",
    is_checked: "",
  },
  {
    title: "일반사항",
    titleRow: false,
    label: "개구부 상의 추락방지<br />- 안전난간, 울타리, 덮개 등 방호조치 설치 상태<br />- 임시로 안전난간 등 해체시 추락방호망 및 안전대 부착설비 설치상태",
    is_checked: "",
  },
  {
    title: "일반사항",
    titleRow: false,
    label: "추락예방 개인보호구(안전대,안전모)<br />- 개인보호구 적정 지급 여부<br />- 지급받은 개인보호구의 적정 착용 여부",
    is_checked: "",
  },
];

export const inspectData_3_1 = [
  {
    title: "기초자료 조사",
    titleRow: 2,
    label: "지반조사보고서 결과 확인<br />- 지층상태, 층후, 지하수위 등의 파악",
    is_checked: "",
  },
  {
    title: "기초자료 조사",
    titleRow: false,
    label: "현장 주변여건 확인",
    is_checked: "",
  },
  {
    title: "사면상태 조사",
    titleRow: 2,
    label: "굴착면 상태 확인<br />- 암반: 절리, 균열, 낙석유무 등<br />- 토사: 표면 토사 유실 등",
    is_checked: "",
  },
  {
    title: "사면상태 조사",
    titleRow: false,
    label: "굴착면 및 바닥부 지하수 유입 상태 확인",
    is_checked: "",
  },
  {
    title: "안전시설 설치조사",
    titleRow: 2,
    label: "굴착면 보호조치 실시여부<br />- 비닐·천막 덮기, 마대 및 가마니 쌓기 등",
    is_checked: "",
  },
  {
    title: "안전시설 설치조사",
    titleRow: false,
    label: "안전휀스 등을 설치 여부",
    is_checked: "",
  },
];

export const inspectData_3_2 = [
  {
    title: "기초자료 조사",
    titleRow: 2,
    label: "설계도서 확인<br />- 시추조사, 도면, 구조계산서, 시방서 등의 확인",
    is_checked: "",
  },
  {
    title: "기초자료 조사",
    titleRow: false,
    label: "주변현황 확인<br />- 인접구조물, 지장물, 인접 공사장 등",
    is_checked: "",
  },
  {
    title: "외관상태 조사",
    titleRow: 2,
    label:
      "조사 및 점검<br />- 부재접합·교차부의 손상·변형·부식·변위·탈락 유무<br />- 벽체수직도·배부름 현상 및 용수유무, 토사유실 확인<br />- 브레이싱, 스티프너, 하중잭, 볼트 등의 적정설치 여부<br />- 복공 및 배면지반 중장비 안치시 안전성 확보 여부",
    is_checked: "",
  },
  {
    title: "외관상태 조사",
    titleRow: false,
    label:
      "조사 및 점검<br />- 부재접합·교차부의 손상·변형·부식·변위·탈락 유무<br />- 벽체수직도·배부름 현상 및 용수유무, 토사유실 확인<br />- 브레이싱, 스티프너, 하중잭, 볼트 등의 적정설치 여부<br />- 복공 및 배면지반 중장비 안치시 안전성 확보 여부",
    is_checked: "",
  },
  {
    title: "안전시설 설치조사",
    titleRow: 1,
    label: "안전시설물 설치 여부<br />- 안전난간, 안전방망 등의 설치 여부<br />- 위험시 경보시설 설치 여부",
    is_checked: "",
  },
];

export const inspectData_3_3 = [
  {
    title: "기초자료 조사",
    titleRow: 2,
    label: "설계도서 확인<br />- 시추조사, 도면, 구조계산서, 시방서 등의 확인",
    is_checked: "",
  },
  {
    title: "기초자료 조사",
    titleRow: false,
    label: "계측수행 및 보고서 작성 여부",
    is_checked: "",
  },
  {
    title: "외관상태 조사",
    titleRow: 2,
    label: "전면부 상태 확인<br />- 파손, 균열, 배부름, 배수공 등의 외관 확인",
    is_checked: "",
  },
  {
    title: "외관상태 조사",
    titleRow: false,
    label: "배면지반 균열, 침하, 융기 등의 이상징후 확인",
    is_checked: "",
  },
  {
    title: "안전시설 설치조사",
    titleRow: 2,
    label: "전면부 보호조치 실시여부<br />- 비닐·천막 덮기, 배수공 등의 추가설치 여부",
    is_checked: "",
  },
  {
    title: "안전시설 설치조사",
    titleRow: false,
    label: "배수로 설치상태 확인 및 청소",
    is_checked: "",
  },
];

export const inspectData_3_4 = [
  {
    title: "기초자료 조사",
    titleRow: 1,
    label: "설계도서 작성여부<br />- 굴착공법(오픈컷, 임시흙막이 등) 심도, 시험시공 등",
    is_checked: "",
  },
  {
    title: "시공상태 확인",
    titleRow: 2,
    label: "굴착면, 지보재 설치 상태 등의 확인<br />- 굴착면 기울기 적정성, 지보재 설치 및 해체 확인",
    is_checked: "",
  },
  {
    title: "시공상태 확인",
    titleRow: false,
    label: "우기 후 작업시 지층상태, 지하수 유입 등 확인",
    is_checked: "",
  },
  {
    title: "안전시설 설치조사",
    titleRow: 1,
    label: "보호조치 실시여부<br />- 우기 시 굴착면 비닐·천막 덮기, 안전휀스 설치 등",
    is_checked: "",
  },
];

export const inspectData_3_5 = [
  {
    title: "기초자료 조사",
    titleRow: 1,
    label: "산업안전보건법 준수 여부<br />- 인증제품 사용 여부",
    is_checked: "",
  },
  {
    title: "시공상태 확인",
    titleRow: 2,
    label: "강풍 대비 비계 설치상태 확인<br />- 설치간격, 연결철물 및 벽이음재 결속상태<br />- 작업발판 설치여부, 적재하중 적정성 등",
    is_checked: "",
  },
  {
    title: "시공상태 확인",
    titleRow: false,
    label: "기초부 침하, 들뜸, 고임부 변형 발생 여부 확인",
    is_checked: "",
  },
  {
    title: "안전시설 설치조사",
    titleRow: 2,
    label: "안전난간, 작업발판 적정 설치여부",
    is_checked: "",
  },
  {
    title: "안전시설 설치조사",
    titleRow: false,
    label: "수직방망, 안전방망 등의 설치 및 결속 여부 확인",
    is_checked: "",
  },
];

export const inspectData_4_1 = [
  {
    title: "안전조치 상태",
    titleRow: 2,
    label: "임시배전반 안전조치 상태<br />- 침수에 대한 안전성 여부<br />- 울타리 높이의 적정성 및 접지 여부<br />- 출입통제를 위한 위험표지판 설치 여부",
    is_checked: "",
  },
  {
    title: "안전조치 상태",
    titleRow: false,
    label: "임시분전반 안전조치 상태<br />- 외함접지 여부<br />- 분전반 시건장치 설치 및 잠김상태 유지 여부<br />- 분전반 내부 회로도 표시 여부<br />- 분기회로에 감전방지용 누전차단기 설치 및 작동여부",
    is_checked: "",
  },
  {
    title: "이동전선 설치상태",
    titleRow: 1,
    label:
      "배선 및 이동전선 설치 상태<br />- 도로 및 통로에 노출 설치여부(지중 또는 가공설치)<br />- 철골 및 철재에 부착여부(전선 거치대를 사용하여 철골 등 철재에 직접 부착되지 않도록 조치)<br />- 옥외 연결사용시 방수형 콘센트 및 플러그 사용여부<br />- 전선 절연피복 및 접지의 파손 여부",
    is_checked: "",
  },
  {
    title: "용접기 사용상태",
    titleRow: 1,
    label: "교류아크 용접기 사용상태의 적정성<br />- 자동전격방지기의 부착 여부<br />- 용접기 외함의 접지 여부<br />- 배선 및 홀더 규격품 사용 및 절연피복의 파손 여부<br />- 단자 접속부의 절연조치 여부",
    is_checked: "",
  },
  {
    title: "양수기 사용상태",
    titleRow: 1,
    label: "수중양수기<br />- 누전차단기를 통한 전원인출 여부<br />- 외함접지 여부<br />- 단자 연결부 절연조치 여부<br />- 양수기 인양로프의 적정성 여부(마닐라로프 사용)",
    is_checked: "",
  },
  {
    title: "기타",
    titleRow: 1,
    label: "기타 기계기구 및 소형 전동공구 사용· 설치 상태<br />- 외함접지 여부(또는 이중 절연구조의 공구 사용)<br />- 전기드릴, 투광기 등 접지형 콘센트의 사용 여부",
    is_checked: "",
  },
];

export const inspectData_5_1 = [
  {
    title: "기초자료 조사",
    titleRow: 2,
    label: "타워크레인을 벽체에 지지하는 경우<br />- 서면심사 서류 또는 제조사 설치작업설명서 준수유무<br />- 지지시설물의 구조적 안전성 검토 유무",
    is_checked: "",
  },
  {
    title: "기초자료 조사",
    titleRow: false,
    label: "타워크레인을 와이어로프에 지지하는 경우<br />- 서면심사 서류 또는 제조사 설치작업설명서 준수<br />- 와이어로프 지지를 위한 전용프레임 사용 준수",
    is_checked: "",
  },
  {
    title: "작업기준 준수",
    titleRow: 4,
    label: "강풍 시 타워크레인 작업 제한 기준 준수<br />- 순간풍속 10m/s 초과시 설치·해체,수리, 점검작업 중지<br />- 순간풍속 15m/s 초과시 운전작업 중지<br />- 순간풍속 30m/s 초과시 초과하는 바람 통과 후에는 작업 개시전 부위 이상유무 점검",
    is_checked: "",
  },
  {
    title: "작업기준 준수",
    titleRow: false,
    label: "설치·상승·해체 작업 시 영상촬영 및 보존",
    is_checked: "",
  },
  {
    title: "작업기준 준수",
    titleRow: false,
    label: "충돌방지조치(인접구조물 등과 충돌위험 있을 시)",
    is_checked: "",
  },
  {
    title: "작업기준 준수",
    titleRow: false,
    label: "설치·상승·해체 작업자 및 운전원 자격유무 확인",
    is_checked: "",
  },
  {
    title: "성능유지 관리",
    titleRow: 5,
    label: "안전인증 및 안전검사 적정 여부",
    is_checked: "",
  },
  {
    title: "성능유지 관리",
    titleRow: false,
    label: "와이어로프 또는 체인 손상 여부<br />- 이음매가 있는 와이어로프, 지름의 감소가 공칭지름의 7퍼센트를 초과하는 와이어로프 등은 사용금지<br />- 제조된 때의 길이의 5퍼센트를 초과하는 체인 사용금지",
    is_checked: "",
  },
  {
    title: "성능유지 관리",
    titleRow: false,
    label: "줄걸이 용구 손상 여부<br />- 훅·샤클·클램프 및 링 등의 철구로서 변형되어 있는 것 또는 균열이 있는 것을 사용해서는 아니 됨<br />- 꼬임이 끊어진 것, 심하게 손상되거나 부식된 섬유로프 또는 섬유벨트를 사용해서는 아니 됨",
    is_checked: "",
  },
  {
    title: "성능유지 관리",
    titleRow: false,
    label: "훅 해지장치 부착여부",
    is_checked: "",
  },
  {
    title: "성능유지 관리",
    titleRow: false,
    label: "방호장치 정상 작동 여부<br />- 과부하방지장치<br />- 권과방지장치<br />- 비상정지장치 및 제동장치",
    is_checked: "",
  },
];

export const inspectData_6_1 = [
  {
    title: "일기예보 모니터링",
    titleRow: 1,
    label: "일기예보 등 모니터링 체계가 갖추어져 있는지 여부",
    is_checked: "",
  },
  {
    title: "수방 매뉴얼",
    titleRow: 1,
    label: "수해 대비 비상 매뉴얼 작성 여부<br />- 매뉴얼에 따른 업무분장의 적정성<br />- 예상 강우량, 우수 유입량, 펌프량의 적정성<br />- 배수 계획도 작성의 적정성",
    is_checked: "",
  },
  {
    title: "비상연락망 구축여부",
    titleRow: 3,
    label: "광범위한 비상연락망 구축 여부<br />- 근로자, 관리감독자, 안전보건총괄책임자 전원에 대한 연락망 구축의 적정성<br />- 건설공사발주차, 소방서, 병원 등 유관기관 담당자 포함 여부",
    is_checked: "",
  },
  {
    title: "비상연락망 구축여부",
    titleRow: false,
    label: "현장 비상대기반 편성·운영 여부<br />- 집중호우시 비상대기반 24시간 운영",
    is_checked: "",
  },
  {
    title: "비상연락망 구축여부",
    titleRow: false,
    label: "비상시 근로자까지 상황 전파 체계 구축 여부<br />- 경보, 경광등, 스피커, 유선전화, 무전기 등 현장 조건에 맞는 상황전파 수단 설치 및 작동 적정성",
    is_checked: "",
  },
  {
    title: "비상대책 수립여부",
    titleRow: 2,
    label: "비상대피계획 수립 여부<br />- 비상 대기반 업무분장의 적정성<br />- 비상 대피로 확보 및 대피 시설의 적정성",
    is_checked: "",
  },
  {
    title: "비상대책 수립여부",
    titleRow: false,
    label: "비상대비 훈련 실시 여부",
    is_checked: "",
  },
  {
    title: "비상용 기구비치",
    titleRow: 1,
    label: "비상용 기구 및 개인보호구 비치 여부<br />- 양수기, 마대, 우비, 장화, 랜턴 등 수방자재 비치<br />- 구명조끼 등 개인보호구 비치",
    is_checked: "",
  },
  {
    title: "배수시설",
    titleRow: 3,
    label: "배수로 확보여부",
    is_checked: "",
  },
  {
    title: "배수시설",
    titleRow: false,
    label: "집수정 및 치사지 설치",
    is_checked: "",
  },
  {
    title: "배수시설",
    titleRow: false,
    label: "현장 주변 배수시설과의 연계상태",
    is_checked: "",
  },
  {
    title: "비상시 출입제한",
    titleRow: 2,
    label: "우수유입 차단시설(수문 등) 설치 및 작동 여부",
    is_checked: "",
  },
  {
    title: "비상시 출입제한",
    titleRow: false,
    label: "비상시 출입통제조치 여부<br />- 비상시 출입인원 통제 체계 수립의 적정성<br />- 출입인원 통제 시설 설치 및 작동의 적정성",
    is_checked: "",
  },
];

export const inspectData_7_1 = [
  {
    title: "사전교육 실시여부",
    titleRow: 1,
    label: "밀폐공간 작업시 특별안전교육 실시<br />- 맨홀작업, 산소결핍장소에서의 작업, 페인트·본드 등 유기용제의 취급 작업 시 관리감독자를 지정하고, 특별안전보건교육 실시 여부",
    is_checked: "",
  },
  {
    title: "환기시설 설치여부",
    titleRow: 9,
    label: "탱크, 저수조 등 밀폐된 공간 내 도장작업시 환기시설 설치 및 정상 작동여부<br />- 도장작업시 도료 등 재료 과다사용 작업 지양",
    is_checked: "",
  },
  {
    title: "환기시설 설치여부",
    titleRow: false,
    label: "분무식 도장작업시 마스크 착용 작업 여부",
    is_checked: "",
  },
  {
    title: "환기시설 설치여부",
    titleRow: false,
    label: "야간 도장작업시 충분한 조명설비 확보 여부",
    is_checked: "",
  },
  {
    title: "환기시설 설치여부",
    titleRow: false,
    label: "맨홀내부, 지하 Pit, 탱크, 바지선하부 선실 등 밀폐된 공간내부의 작업전 산소농도 측정 여부<br />- 밀폐된 공간내에서 작업전·작업중에는 산소농도 18%이상 유지되도록 송풍, 환기 실시 및 농도 측정",
    is_checked: "",
  },
  {
    title: "환기시설 설치여부",
    titleRow: false,
    label: "맨홀내부, 터널내부 등 환기가 불충분한 장소에서 엔진양수기, 오거보링기, 페이로더 등 내연기관이 부착된 장비 사용 여부<br />- 환기가 불충분한 장소에서 내연기관이 부착된 장비 사용시 소요 환기량을 산정하여 적정 환기시설 설치",
    is_checked: "",
  },
  {
    title: "환기시설 설치여부",
    titleRow: false,
    label: "아르곤가스 등 불활성가스가 들어있거나, 들어 있었던 탱크나 시설의 내부 작업 전 산소농도 측정 여부",
    is_checked: "",
  },
  {
    title: "환기시설 설치여부",
    titleRow: false,
    label: "비상용 기구 및 개인보호구 비치 여부<br />- 산소농도측정결과 산소농도 18%이하일 경우 18%이상 유지될 수 있도록 지속적인 환기 및 농도 측정",
    is_checked: "",
  },
  {
    title: "환기시설 설치여부",
    titleRow: false,
    label: "밀폐된 공간에서 본드 등 접착제를 사용 작업(유기용제 취급작업)시에는 국소박이 장치 등 환기설비 설치 여부",
    is_checked: "",
  },
  {
    title: "환기시설 설치여부",
    titleRow: false,
    label: "지하 정화조, 저수조 등 밀폐된 공간내에 거푸집동바리 설치, 콘크리트 타설, 콘크리트 양생후 거푸집 동바리 해체 작업 시 작업 전 산소농도 측정",
    is_checked: "",
  },
  {
    title: "보호구 및 대피계획",
    titleRow: 2,
    label: "산소결핍 우려지역 작업시에는 송기마스크, 공기호흡기, 산소호흡기 등 호흡용 보호구 지급 착용 여부",
    is_checked: "",
  },
  {
    title: "보호구 및 대피계획",
    titleRow: false,
    label: "사고발생 등 긴급사태 발생 시 근로자의 피난, 구출 등을 위한 사다리 및 섬유로프 등 비치 여부",
    is_checked: "",
  },
];

export const inspectData_8_1 = [
  {
    title: "사전교육 실시여부",
    titleRow: 1,
    label: "화기작업시 특별안전교육 실시<br />- 용접·용단 또는 가열하는 작업시 특별안전보건교육 실시 여부<br />- 밀폐된 장소에서 하는 용접작업 또는 습한 장소에서 하는 전기용접 작업시 특별안전보건교육 실시 여부",
    is_checked: "",
  },
  {
    title: "작업기준 준수여부",
    titleRow: 7,
    label: "인화성 액체 취급장소 및 화재위험장소의 안전조치 여부<br />- 가연성,인화성 물질 다량 취급장소의 화재예방을 위한 작업 배치",
    is_checked: "",
  },
  {
    title: "작업기준 준수여부",
    titleRow: false,
    label: "가스용접작업시 안전조치 여부<br />- 가스 호스와 취관의 이상유무 점검 및 공급구의 밸브나 콕에 사용자 명찰 부착 등 오조작 방지조치",
    is_checked: "",
  },
  {
    title: "작업기준 준수여부",
    titleRow: false,
    label: "가스용기 관리 여부<br />- 가스용기의 방치 여부 및 부식·마모·변형여부 점검",
    is_checked: "",
  },
  {
    title: "작업기준 준수여부",
    titleRow: false,
    label: "위험물이 있는 장소에서 화기 사용 여부<br />- 화재 또는 폭발이 발생할 우려가 있는 장소 또는 그 상부에서 불꽃이나 아크를 발생하거나 고온으로 될 우려가 있는 기계·기구·공구 사용 금지",
    is_checked: "",
  },
  {
    title: "작업기준 준수여부",
    titleRow: false,
    label: "유류가 있는 배관이나 용기의 용접작업 여부<br />- 위험물, 인화성 유류, 인화성 고체가 있는 배관·탱크·드럼 용기에 대해 미리 제거하고 작업",
    is_checked: "",
  },
  {
    title: "작업기준 준수여부",
    titleRow: false,
    label: "화재위험작업의 준수사항 이행 및 서면게시, 화재감시자의 배치 여부<br />- 화재위험 작업을 하는 경우 화재위험을 감시하고 화재발생시 근로자 대피를 유도하는 화재감시자를 지정하여 배치",
    is_checked: "",
  },
  {
    title: "작업기준 준수여부",
    titleRow: false,
    label: "인화성 가스 발생 우려가 있는 지하작업장 또는 가스가 발산될 위험이 있는 장소에서 작업시 화재·폭발 방지 조치 여부<br />- 가스농도 측정자를 지명하고 측정하되 위험판단시 근로자 대피 및 화기 사용을 중지하며 통풍 ∙ 환기",
    is_checked: "",
  },
];
